/**
 * Number only input
 */

import $ from 'jquery';

const $el = {
	input: $('.js-num-lock'),
};

function init() {
	if (!$el.input.length) return;

	$el.input.each(function() {
		const $input = $(this);

		$input.on('keydown', e => numLock(e));
	});
}

function numLock(e) {
	if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 || // Allow: backspace, delete, tab, escape, enter and .
		(e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || // Allow: Ctrl+A, Command+A
		(e.keyCode >= 35 && e.keyCode <= 40)) { // Allow: home, end, left, right, down, up
		return;
	}

	// Ensure that it is a number and stop the keypress
	if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
		(e.keyCode < 96 || e.keyCode > 105)) {
		e.preventDefault();
	}
}

export default init;